import * as React from "react";
export class SportHeader extends React.PureComponent {
    render() {
        return (React.createElement("h3", { className: "rj-league-list__sport-header", "data-uat": "h3-league-list-sport-header" },
            React.createElement("span", { className: "rj-league-list__header-title", "data-uat": "span-league-list-sport-header-title" }, this.props.label),
            this.props.children));
    }
}
//# sourceMappingURL=SportHeader.js.map